<template>

  <div>

    <EnterpriseImportDialog :foreign-key="enterpriseId" :reference="reference" v-if="type==='enterprise'" @onSubmit="onEnterpriseImportDialog"/>

    <b-modal size="xl" @hide="closeSearch()" ref="modal" no-close-on-esc id="modal-import-models"
             no-close-on-backdrop
             ok-only
             @show="onShow"
             @ok="handleOk"
             :title="title + ' disponíveis'">

      <b-row>

        <t-input cols="3" v-model="form.default" :label="'Pesquisar'"
                 @keyup.enter.native="executeSearchInput"/>


        <t-input cols="3" v-model="form.sector" v-if="type === 'type-pathology'" label="Categoria"
                 @keyup.enter.native="executeSearchInput"/>

        <t-input cols="3" v-model="form.typeRegulation" v-if="type === 'regulation'" label="Categoria"
                 @keyup.enter.native="executeSearchInput"/>


        <b-col cols="3">

          <t-button @click="executeSearchInput" class="ml-3" outline-secondary form-inline>
            <b-icon-search class="mr-1" style="scale: 0.8"></b-icon-search>
            Filtrar
          </t-button>

        </b-col>

      </b-row>


      <div style="overflow: hidden; position: relative; float: left; width: 100%">

        <t-msg info v-if="msgInfo !== ''">{{ msgInfo }}</t-msg>

        <t-table
            @getPage="getPageSearchList"
            :show="checkViewListTableDefault()"
            :enable-radio="unique"
            :enable-checked="!unique"
            v-model="importedId"
            :filtered="filtered"
            :busy="!pageListIsLoaded || onSending"
            :user-auth="userAuth"
            :items="request.content"
            :fields="fields"
            :total-pages="request.totalPages"
            :total-elements="request.totalElements"
            :container-table-style="[{'min-height':'250px'}]"
            table-bordered
            table-striped
            :primary-key-column="primaryKeyColumn"
            :link-primary-column="linkPrimaryColumn"
            disable-actions-column>

          <template #item(modelEnterprise)="{item}">

            <div v-if="item.modelEnterprise">
              <b-badge variant="info">Específico</b-badge>
            </div>

            <div v-else>
              Padrão
            </div>

          </template>

        </t-table>

      </div>

      <template #modal-footer="{ok}">

        <t-button @click="ok()" v-if="type === 'enterprise'" class="pr-5 pl-5"
                  primary>Avançar com Importação
          <b-icon-arrow-right class="ml-2"/>
        </t-button>

        <t-button @click="ok()" v-else class="pr-5 pl-5" :text="'Importar ' + title"
                  :sending="onSending"
                  submit
                  primary/>

      </template>

    </b-modal>

  </div>


</template>
<script>

import pageInputSearchListMixin from "@/mixins/page/pageInputSearchListMixin";
import ui from "@/assets/scripts/ui";
import EnterpriseImportDialog from "@/views/modules/place/EnterpriseImportDialog";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
  name: 't-dialog-import-models',
  mixins: [pageInputSearchListMixin],
  components: {EnterpriseImportDialog},
  data() {
    return {
      status: "",
      path: "", //Utilizando conforme vindo entityPath
      importedId: [],
      enterpriseId:0,
      reference: "",
      msgInfo: '',
      form: {
        default: "",
        sector: "",
        typeRegulation: "",
      },
      title: "",
      unique: true,
      primaryKeyColumn: "",
      linkPrimaryColumn: "",
      fields: [],
    }
  },
  props: {
    type: String,
  },

  computed: {
    onStatus() {
      return this.status
    },
  },
  methods: {

    async mountedPrepare() {

      if (this.type === 'enterprise') {

        this.unique = true
        this.path = 'place/enterprise/import'
        this.title = 'Empreendimento'
        this.primaryKeyColumn = 'enterpriseId'
        this.linkPrimaryColumn = "title"

        this.fields = [
          {key: "title", label: "Empreendimento"},
          {key: "modelEnterprise", label: "Tipo"},
          {key: "note", label: "Informações"},
        ]

      } else if (this.type === 'type-environment') {

        this.unique = false
        this.path = 'place/type-environment/import'
        this.title = 'Modelo de Ambiente'
        this.primaryKeyColumn = 'typeEnvironmentId'
        this.linkPrimaryColumn = "name"
        this.fields = [
          {key: "name", label: "Modelo de Ambiente"},
          {key: "qtyItems", label: "Qtd. Itens"},
          {key: "note", label: "Informações"},
        ]

      } else if (this.type === 'type-pathology') {

        this.unique = false
        this.path = 'checklist/type-pathology/import'
        this.title = 'Anomalia'
        this.primaryKeyColumn = 'typePathologyId'
        this.linkPrimaryColumn = "name"
        this.fields = [
          {key: "name", label: "Anomalia"},
          {key: "sector", label: "Categoria"},
        ]

      } else if (this.type === 'regulation') {

        this.path = 'checklist/regulation/import'
        this.title = 'Normas Técnicas'
        this.primaryKeyColumn = 'regulationId'
        this.linkPrimaryColumn = "title"
        this.unique = false
        this.fields = [
          {key: "name", label: "Norma"},
          {key: "title", label: "Título"},
          {key: "typeRegulation", label: "Categoria"},
          {key: "note", label: "Informações"},
        ]

      }

      if (this.unique) {
        this.importedId = 0
        this.msgInfo = ''
      } else {
        this.importedId = []
        this.searchParams.delete('pageSize')
        this.searchParams.append('pageSize', "20")
        this.msgInfo = 'Listagem somente de registros que não foram importados anteriormente'
      }

      this.pageNumber = 1

      await this.getPageSearchList(this.pageNumber, false)

      this.pageListIsLoaded = true

    },

    async onChosen() {

      if (this.type === 'enterprise') {
        this.openEnterpriseImportDialog()
      } else {

        let pathImport = this.path
        let data = ""

        if (this.unique) {
          pathImport += "/" + this.importedId //Enviado no header
        } else {
          data = this.importedId //Enviado no corpo
        }

        this.onSending = true
        let item

        await crudGeneral.create(pathImport, data)
            .then(response => {
              item = response.data
            })
            .catch(error => {
              console.log('Erro externo: ' + error)
            })

        this.onSending = false
        this.$emit('onSubmit', item)

      }

    },
    async executeAfterSearch() {

    },

    openEnterpriseImportDialog(){

      this.enterpriseId = this.importedId
      this.reference = this.request.content.find(a => a.enterpriseId === this.importedId).title

      this.openModal('modal-enterprise-import')

    },

    onEnterpriseImportDialog(item) {

      console.log('Empreendimento importado!')
      this.$emit('onSubmit', item)

    },

    async onShow() {
      await this.mountedPrepare()
    },

    async handleOk(bvModalEvt) {

      bvModalEvt.preventDefault()

      if (this.unique) {

        if (this.importedId === 0) {
          ui.msgError(this, 'Selecione o empreendimento desejado para importação');
        } else {
          await this.onChosen()
        }

      } else {

        if (this.importedId === 0) {
          ui.msgError(this, 'Selecione pelo menos 1 modelo de ambiente que deseja importar');
        } else {
          await this.onChosen()
        }

      }

    },

  },
}
</script>
